import {FC, ReactNode, useEffect, useState} from 'react'
import styles from './BaseModal.module.css'
import Swal from 'sweetalert2'

type Props = {
  onCloseAction: () => void
  title: string
  children: ReactNode
  width?: string
  disableClose?: boolean
  editPageProduct?: boolean
}

const BaseModal: FC<Props> = ({
  onCloseAction,
  title,
  children,
  width = '30rem',
  disableClose = false,
  editPageProduct = false,
}) => {
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = () => {
    if (disableClose) onCloseAction()
    else {
      Swal.fire({
        title: 'Atenção!',
        text: 'As mudanças feitas serão perdidas, tem certeza que deseja sair?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result) => {
        if (result.isConfirmed) {
          setIsClosing(true)
          setTimeout(() => {
            onCloseAction()
          }, 300)
        }
      })
    }
  }

  return (
    <>
      <div
        onClick={handleClose}
        className={`${styles.background} ${isClosing ? styles.fadeOut : ''}`}
      ></div>
      <div className={`${styles.modalCustom} ${isClosing ? styles.slideOut : ''}`} style={{width}}>
        <div className={styles.modalContent}>
          <div className={styles.modalHeader}>
            <h3 className={styles.modalTitle}>{title}</h3>
            <button type='button' className={styles.closeButton} onClick={handleClose}>
              <i className={`fas fa-times ${styles.closeButtonIcon}`}></i>
            </button>
          </div>
          <div className={!editPageProduct ? styles.modalBody : styles.modalBodyEdit}>
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export {BaseModal}
